import { Component } from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {CommonModule} from '@angular/common';

// Define interfaces for the data models
interface Plug {
  id: string;
  name: string;
  status: 'in-use' | 'available';
  type: string;
}

interface Charger {
  addedOn: string;
  lastActionBy: string;
  model: string;
  serialNumber: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  latitude: string;
  longitude: string;
  owner: string;
  tariff: string;
  price: string;
  cgst: string;
  sgst: string;
  igst: string;
}

@Component({
  selector: 'app-charger-info',
  imports: [
    MatIcon,
    CommonModule // Add this for *ngFor
  ],
  templateUrl: './charger-info.html',
  styleUrl: './charger-info.css',
})
export class ChargerInfo {
  charger: Charger = {
    addedOn: '12/01/2026',
    lastActionBy: 'Srinivas Kumar Choudhary',
    model: 'Maruti Suzuki',
    serialNumber: '401171',
    address1: 'No. 352/353, Sai Chowk, Jawaharlal Nehru Rd',
    address2: 'Shastri Nagar, Pimpri Colony',
    city: 'Pune',
    state: 'Maharastra',
    zip: '411017',
    country: 'India',
    latitude: '18.6280',
    longitude: '73.8070',
    owner: 'Clean Electric',
    tariff: 'Standard AC Charging – Residential',
    price: '₹18.00',
    cgst: '0%',
    sgst: '9%',
    igst: '9%'
  };

  // Array of plugs that will come from backend
  plugs: Plug[] = [
    {
      id: '1',
      name: 'Plug_1',
      status: 'in-use',
      type: 'Type_6_DC'
    },
    {
      id: '2',
      name: 'Plug_2',
      status: 'available',
      type: 'GB/T_DC'
    }
  ];

  // Methods to handle actions
  editPlug(plug: Plug): void {
    console.log('Edit plug:', plug);
    // Implement edit logic
  }

  deletePlug(plug: Plug): void {
    console.log('Delete plug:', plug);
    // Implement delete logic
  }
}
